import { actions } from '@ecosystem/newron-design-system';
import React from 'react';

import { PageName, Product, ShowSliderButtonId, SlidesByType } from '../common';
import { ConsumerSlidesMessage } from '../components/consumer-slides-message';
import { MarketMessageImage } from '../components/images';
import { ConsumerStoriesRLSSlideMessage } from '../components/slides/consumer-stories-retail-lost-shoppers-slide/ConsumerStoriesRLSSlideMessage';

export type UpsellMessageType = (props: {
  onClose?: () => void;
  onShowMore?: () => void;
  pageName?: PageName;
  bannerIndex?: number;
}) => JSX.Element;

const getMarketUpsellMessage = (slidesType?: SlidesByType): UpsellMessageType => {
  const { Button } = actions;
  let message: UpsellMessageType = null;

  if (slidesType === SlidesByType.CONSUMER_LOST_SHOPPER) {
    message = ConsumerSlidesMessage;
  } else if (slidesType === SlidesByType.DEFAULT) {
    message = () => (
      <div className="flex flex-column Upsell-Market-message-image">
        <MarketMessageImage />
        <p className="mt-4 mb-6 px-6">B2B channels offer better growth opportunities in turbulent times.</p>
        <div className="text-right px-6 pb-4">
          <Button testId={ShowSliderButtonId} onClick={() => {}}>
            See KBQs to boost your B2B sales
          </Button>
        </div>
      </div>
    );
  }

  return message;
};

const getRetailUpsellMessage = (slidesType?: SlidesByType): UpsellMessageType => {
  let message: UpsellMessageType = null;
  if (slidesType === SlidesByType.CONSUMER_LOST_SHOPPER) {
    message = ConsumerSlidesMessage;
  }
  if (slidesType === SlidesByType.CONSUMER_RETAIL_LOST_SHOPPER) {
    message = ConsumerStoriesRLSSlideMessage;
  }

  return message;
};

export const getUpsellMessage = (products: Product[] = [], slidesType?: SlidesByType): UpsellMessageType => {
  let message: UpsellMessageType = null;

  if (products.includes(Product.Market)) {
    message = getMarketUpsellMessage(slidesType);
  } else if (products.includes(Product.Retail)) {
    message = getRetailUpsellMessage(slidesType);
  }

  return message;
};
